import { DashboardWidgetData } from 'features/widget/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import TopAuthorsType, {
  TopAuthorsTypeStrings
} from 'components/insightContent/enum/TopAuthorsType'
import i18n from 'i18n'

interface RowData {
  followers: InsightData['followers']
  domain: InsightData['domain']
  dataStreams: InsightData['dataStreams']
  authorVerified: InsightData['authorVerified']
  authorName: InsightData['authorName']
  authorLink: InsightData['authorLink']
  author: InsightData['name']
  authorAvatarUrl: InsightData['authorAvatarUrl']
  authorDescription: InsightData['authorDescription']
  authorHandle: InsightData['authorHandle']
  authorID: InsightData['authorID']
  authorFingerprint: InsightData['authorFingerprint']
}

const retrieveDataset = (response: DashboardWidgetData<InsightCount>[]) =>
  response?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]?.set || []

/**
 * convert responses from runsearch to data displayed on table
 * @param searchResponses responses from runsearch
 */
export const convertToTableData = (searchResponses: DashboardWidgetData<InsightCount>[]) => {
  const rowData = retrieveDataset(searchResponses)?.map((dataSet) => ({
    followers: dataSet.followers,
    domain: dataSet.domain,
    dataStreams: dataSet.dataStreams,
    authorVerified: dataSet.authorVerified,
    authorName: dataSet.authorName,
    authorLink: dataSet.authorLink,
    author: dataSet.name,
    authorAvatarUrl: dataSet.authorAvatarUrl,
    authorDescription: dataSet.authorDescription,
    authorHandle: dataSet.authorHandle,
    authorID: dataSet.authorID,
    authorFingerprint: dataSet.authorFingerprint
  }))
  return rowData || []
}

export const findMaxValue = (rowData: RowData[]) => {
  if (rowData.length === 0) {
    return null
  }

  let maxFollowersAuthor = rowData[0] || 0

  for (let i = 1; i < rowData.length; i += 1) {
    if (rowData[i]?.followers) {
      if (rowData[i].followers! > maxFollowersAuthor.followers!) {
        maxFollowersAuthor = rowData[i]
      }
    }
  }

  return maxFollowersAuthor.followers
}

export const getNumberFormatter = () =>
  new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })

export const getHeaderText = (postType: TopAuthorsTypeStrings) => {
  switch (postType) {
    case TopAuthorsType.REPOSTS:
      return i18n.t('repostedBy')
    case TopAuthorsType.REPLIES:
      return i18n.t('repliedBy')
    case TopAuthorsType.MENTIONS:
      return i18n.t('mentionedBy')
    default:
      return i18n.t('repostedBy')
  }
}
